import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AuthActions } from '../../store';
import { Footer } from '../Footer/Footer';
import './Login.css';

const logo = require('./assets/login-logo.png');

export class Login extends Component {
  state = {
    email: '',
    password: '',
  };

  updateEmail(e) {
    const email = e.target.value;

    this.setState((state) => ({
      ...state,
      email,
    }));
  }

  updatePassword(e) {
    const password = e.target.value;

    this.setState((state) => ({
      ...state,
      password,
    }));
  }

  login(e) {
    e.preventDefault();
    const { email, password } = this.state;
    if (email && password) {
      this.props.login(email, password);
    } else {
      this.props.setLoginError('Please enter a username & password.');
    }
  }

  render() {
    const { email, password } = this.state;

    // grab user token and check if it exists (does not validate here - TODO)
    const token = JSON.parse(window.sessionStorage.token || '{}');
    if (this.props.loggedIn && token) {
      if (this.props.location.state) {
        if (this.props.location.state.from) {
          return <Redirect to={`${this.props.location.state.from}`} />;
        } else {
          return <Redirect to="/" />;
        }
      } else {
        return <Redirect to="/" />;
      }
    }

    // set error message visibility depending on state
    let loginMessageClasses = 'login__message';
    loginMessageClasses += this.props.error ? ' login__message--error' : '';

    return (
      <div className="login">
        <div className="login-content">
          <div className="login-logo-wrapper">
            <img className="login__logo" src={logo} alt="Parity" />
          </div>
          <div className="login-fields-wrapper">
            <div className="login-fields">
              <div className="login__text">Log in with a Parity account</div>
              <form onSubmit={(e) => this.login(e)} className="login-form">
                <input
                  className="login__input"
                  value={email}
                  onChange={(e) => this.updateEmail(e)}
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                />
                <input
                  className="login__input"
                  value={password}
                  onChange={(e) => this.updatePassword(e)}
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Password"
                />
                <div className={loginMessageClasses}>{this.props.error}</div>
                <button type="submit" className="login__button">
                  Log in
                </button>
              </form>
              <Link to="/forgot-password" className="login__password-reset">
                Forgot your password?
              </Link>
            </div>
          </div>
        </div>
        <Footer light={true} />
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func,
  loggedIn: PropTypes.bool,
  error: PropTypes.string,
  setLoginError: PropTypes.func.isRequired,
};

Login.defaultProps = {
  login: undefined,
  loggedIn: undefined,
  error: undefined,
};

function mapStateToProps(state) {
  return {
    loggedIn: state.authReducer.loggedIn,
    error: state.authReducer.error,
  };
}

const mapDispatchToProps = {
  login: AuthActions.login,
  setLoginError: AuthActions.setLoginError,
};

const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
export { ConnectedLogin };
